Vendd.Scripts.load(function () {
    wishlistArticleBindClicks = function ($control) {
        $control.on('click', '.js-add-to-wishlistArticle', function (e) {
            e.preventDefault();
            e.stopPropagation();
            articleId = $(this).closest('.x-article-box').data('article-id');
            articleUrl = $(this).closest('.x-article-box').data('article-url');
            var id = articleId,
                path = articleUrl,
                extraAttributes = [],
                bundleItems = null;
            var $removeBox = $(this).closest('.x-article-box').find('.in-wishlistArticle-wrapper');
            $removeBox.removeClass('disabled');
            $removeBox.find('.js-remove-from-wishlistArticle').prop("disabled", false);
            Vendd.MessageBus.publishAsync($control.get(0), new Vendd.WishlistArticle.Messages.Add(id, path, extraAttributes, bundleItems));
            Vendd.MessageBus.publishAsync($control.get(0), new Vendd.Widget.Messages.OpenWidget(Vendd.Widget.WishlistArticleWidget, false));
        });

        $control.on('click', '.js-remove-from-wishlistArticle', function (e) {
            e.preventDefault();
            e.stopPropagation();
            articleId = $(this).closest('.x-article-box').data('article-id');
            Vendd.MessageBus.publishAsync($control.get(0), new Vendd.WishlistArticle.Messages.Remove(articleId));
            Vendd.MessageBus.publishAsync($control.get(0), new Vendd.Widget.Messages.OpenWidget(Vendd.Widget.WishlistArticleWidget, false));
        });

        Vendd.MessageBus.subscribe(Vendd.WishlistArticle.Messages.Changed, 'x-article-box', function (envelope) {
            var data = envelope.message.data.Items; addEventListener
            var $boxes = $('.x-article-box');

            if ($boxes.length < 1)
                return;

            $boxes.each(function (i, el) {
                var $el = $(el);
                var id = $el.data('article-id');

                $el.find('.js-remove-from-wishlistArticle').attr('disabled', 'disabled').parent().addClass('disabled');

                for (var j = 0; j < data.length; j++) {
                    if (id == data[j].ArticleId) {
                        $el.prop('data-article-id', data[j].Id);
                        $el.find('.js-remove-from-wishlistArticle').removeAttr('disabled').parent().removeClass('disabled');
                    }
                }
            });
        });
    }
    $control = $('.x-article-box');
    wishlistArticleBindClicks($control);

    var $wrapper = $('.x-article-list');

    var model = null;

    if ($wrapper.length < 1)
        return;

    var $scrolledWrapper = $('.x-article-list[data-scrolled=true]'),
        scrolledWrapper,
        $configuration, configuration,
        partial = 'articleList',
        isScrolled = $scrolledWrapper.data('scrolled') === true,
        totalPages = isScrolled ? parseInt($scrolledWrapper.data('total-pages')) : 0,
        forwardUpdates = 0,
        forwardUpdatesCup = 2,
        loading = false,
        hasNext = true;

    if ($scrolledWrapper.length < 1)
        return;

    scrolledWrapper = $scrolledWrapper.get(0);

    if ($scrolledWrapper.data('template')) {
        partial = $scrolledWrapper.data('template');
    }

    $configuration = $('#configuration', $scrolledWrapper);
    configuration = $configuration.text();
    $configuration.remove();

    scrolledWrapper.loading = function () {
        if (loading === true) {
            $scrolledWrapper.addClass('x-loading');
        } else {
            $scrolledWrapper.removeClass('x-loading');
            if (forwardUpdates >= forwardUpdatesCup) {
                $('.scrolllist-pager-notification').removeClass('x-loading');
            }
        };
    };

    scrolledWrapper.onSuccess = function (envelope) {
        if (envelope.message.data.list !== scrolledWrapper)
            return;

        model = envelope.message.data.model;

        /*insert literal to async model */
        var literal = $(".js-more-literal").html();
        model.PageViewModel = {
            Literals: {
                more_button: literal
            }
        };

        var html = Vendd.Handlebars.parse(partial, model);

        var $html = $(html),
            $list = $('> ul', $scrolledWrapper),
            $boxes,
            items, lastItem, grouping, rowSize;

        configuration = $('#configuration', $html).text();

        $boxes = $('.x-article-box', $html);

        lastItem = $list.children().last();
        grouping = $html.data('grouping');
        rowSize = 0;

        items = wrapBoxes($boxes, grouping, rowSize, lastItem);

        if (parseInt($scrolledWrapper.attr('data-total-pages')) == model.PageNumber) {
            $('.scrolllist-pager-notification').remove();
        }

        $list.append(items);

        loading = false;

        scrolledWrapper.loading(loading);

    };

    scrolledWrapper.onFailure = function (envelope) {
        if (envelope.message.data.list !== scrolledWrapper)
            return;

        loading = false;
        scrolledWrapper.loading(loading);
    };

    scrolledWrapper.update = function () {

        hasNext = totalPages > parseInt($('>ul>li[data-page]', $scrolledWrapper).eq($('>ul>li[data-page]', $scrolledWrapper).length - 1).attr('data-page'));

        if (loading || hasNext === false)
            return;

        loading = true;
        scrolledWrapper.loading(loading);
        Vendd.MessageBus.publishAsync(scrolledWrapper, new Vendd.ScrollList.Messages.GetNextPage(scrolledWrapper, configuration, 'articleList'));
    };

    Vendd.MessageBus.subscribe(Vendd.ScrollList.Messages.GetPageSuccess, scrolledWrapper, scrolledWrapper.onSuccess);
    Vendd.MessageBus.subscribe(Vendd.ScrollList.Messages.GetNextPageFailure, scrolledWrapper, scrolledWrapper.onFailure);

    scrolledWrapper.updatePageUrl = function () {

        var element = _.first(_.filter($('>ul>li[data-page]', $scrolledWrapper), function (element) { return $(window).scrollTop() <= $(element).offset().top; })),
            pageNumber = $(element).length ? $(element).data('page') : $('>ul>li[data-page]', $scrolledWrapper).eq($('>ul>li[data-page]', $scrolledWrapper).length - 1).data('page'),
            pager = $('.x-pager[data-page-count]'),
            pageCount = pager.length ? (parseInt(pager.attr('data-page-count')) || 0) : 0,
            comboPagers = $('.pager .x-pager-combopages');

        comboPagers.each(function (index, comboPager) {
            var $comboPager = $(comboPager);
            $('select', $comboPager).addClass('disabled');
            $('.newList>li a', $('select', $comboPager).siblings('.newListSelected')).eq(pageNumber - 1).trigger('click');
            $('select', $comboPager).removeClass('disabled');
        });

        if (history.pushState) {

            var querystring = window.location.pathname + (window.location.pathname.slice(-1) != "/" ? "/" : ""),
                pageText = pageNumber > 1 ? "p" + pageNumber + "/" : "";

            if (!(/\/P\d+\//i.test(querystring))) {
                querystring = querystring + pageText;
            } else {
                querystring = querystring.replace(/\/P\d+\//i, "/" + pageText);
            }

            var stateObject = {};
            var url = window.location.protocol
                + "//"
                + window.location.host
                + querystring
                + window.location.search;

            if (window.location.href !== url) {
                var prev = $("head link[rel=prev]");
                var next = $("head link[rel=next]");
                var prevLink = url.replace(/^(.+\/p)\d+(\/?(\?.*)?)?$/i, "$1" + (pageNumber - 1) + "$2");
                var nextLink = url.replace(/^(.+\/p)\d+(\/?(\?.*)?)?$/i, "$1" + (pageNumber + 1) + "$2");
                if (prev) {
                    if (pageNumber > 1) {
                        prev.attr("href", prevLink);
                    } else {
                        prev.remove();
                    }
                } else if (pageNumber > 1) {
                    $("head").append("link rel=\"prev\" href=\"" + prevLink + "\" />");
                }
                if (next) {
                    if (pageNumber < pageCount) {
                        next.attr("href", nextLink);
                    } else {
                        next.remove();
                    }
                } else if (pageNumber < pageCount) {
                    $("head").append("link rel=\"next\" href=\"" + nextLink + "\" />");
                }
                history.replaceState(stateObject, jQuery(document).find('title').text() + pageNumber, url);
            }
        }
    }

    function wrapBoxes($boxes, grouping, rowSize, lastItem) {
        var items = [],
            currentIndex, cssClass;

        lastItem.removeClass('last');

        currentIndex = lastItem.data('index') + 1;

        for (var i = 0; i < $boxes.length; i++) {
            var li = $('<li>');

            cssClass = "index" + currentIndex;
            cssClass += (currentIndex % 2) ? " odd" : " even";
            cssClass += (i === $boxes.length - 1) ? " last" : "";

            cssClass += rowSize === 0 ? "" : currentIndex % rowSize === 0 ? " row-first" : "";
            cssClass += rowSize === 0 ? "" : (currentIndex + 1) % rowSize === 0 ? " row-last" : "";

            li.append($boxes.eq(i))
                .addClass(cssClass)
                .attr('data-index', currentIndex)
                .attr('data-page', model.PageNumber);

            items.push(li);

            currentIndex++;
        };

        return items;
    };

    $('.scrolllist-pager-notification').on('click', '.js-show', function () {
        forwardUpdates = 0;
        $('.scrolllist-pager-notification').addClass('x-loading');
        scrolledWrapper.update();
    });

    if (isScrolled === true) {
        $(window).scroll($.debounce(300, function () {
            if (($(window).scrollTop() >= $(document).height() - $(window).height() - $('.footer-region').height() - 100 || isElementInViewport($('.scrolllist-pager-notification'))) && forwardUpdates < forwardUpdatesCup) {
                forwardUpdates++;
                scrolledWrapper.update();
                $scrolledWrapper.removeClass('x-loading');
            };
            if ($(window).scrollTop() >= 0 && !loading) {
                scrolledWrapper.updatePageUrl();
            }
        }));
    };
});
